var map = {
	"./BookOpen_2022.svg": 73334,
	"./Envelope_2022.svg": 91503,
	"./Link_2022.svg": 63799,
	"./arrow-down-wide.svg": 85098,
	"./arrow-down.svg": 16450,
	"./arrow-left.svg": 32329,
	"./arrow-right.svg": 23220,
	"./arrow-rounded.svg": 74357,
	"./arrow-short.svg": 29816,
	"./arrows-right.svg": 4917,
	"./asterix.svg": 60880,
	"./book.svg": 27677,
	"./calendar.svg": 3484,
	"./camera.svg": 41507,
	"./category-apple.svg": 6965,
	"./category-building.svg": 43063,
	"./category-democracy.svg": 46610,
	"./category-factory.svg": 62815,
	"./category-globe.svg": 70934,
	"./category-grain.svg": 50308,
	"./category-handshake.svg": 2682,
	"./category-heart.svg": 23657,
	"./category-iceberg.svg": 33414,
	"./category-ocean.svg": 29315,
	"./category-oil-drum.svg": 93498,
	"./category-people.svg": 59762,
	"./category-sami.svg": 6981,
	"./category-science.svg": 91951,
	"./category-tree.svg": 19447,
	"./category-windmill.svg": 99607,
	"./change.svg": 92906,
	"./chat.svg": 4836,
	"./check-circle.svg": 50979,
	"./checkmark.svg": 81633,
	"./chevron-down.svg": 46068,
	"./clock.svg": 6804,
	"./close-small.svg": 69448,
	"./document.svg": 13013,
	"./download-circle.svg": 94083,
	"./download-round-large.svg": 17159,
	"./download-round.svg": 1081,
	"./download-small.svg": 71308,
	"./download.svg": 95942,
	"./downtime.svg": 35761,
	"./dubian-path.svg": 40763,
	"./envelope.svg": 20518,
	"./error-page.svg": 92152,
	"./exclamation-mark-color.svg": 54023,
	"./exclamation-mark.svg": 44177,
	"./expand-collapse.svg": 44510,
	"./external-link-arrow-skinny.svg": 39305,
	"./external-link-arrow.svg": 68928,
	"./facebook-logo.svg": 79386,
	"./facebook.svg": 73610,
	"./file.svg": 86236,
	"./filter-small.svg": 98102,
	"./flag.svg": 39172,
	"./globe.svg": 27813,
	"./house.svg": 30134,
	"./i.svg": 78659,
	"./info-color.svg": 5488,
	"./info.svg": 51358,
	"./link-arrow-circled.svg": 42361,
	"./link-arrow.svg": 66250,
	"./link.svg": 66926,
	"./linkedin-logo.svg": 37080,
	"./linkedin.svg": 99760,
	"./long-arrow.svg": 72432,
	"./mail-square.svg": 79225,
	"./mail-thick.svg": 64307,
	"./mail.svg": 47187,
	"./menu.svg": 89943,
	"./micro-arrow-down.svg": 68151,
	"./minus-small.svg": 81752,
	"./navigation-arrow.svg": 17412,
	"./np-1.svg": 97322,
	"./np-2.svg": 72345,
	"./np-3.svg": 6952,
	"./np-4.svg": 96135,
	"./np-5.svg": 32310,
	"./np-6.svg": 4181,
	"./np-circle.svg": 95473,
	"./np-close.svg": 53515,
	"./np-dash-bottom-right.svg": 91030,
	"./np-dash-top-right.svg": 41506,
	"./np-dash-top-top.svg": 18157,
	"./np-long-horizontal.svg": 77240,
	"./np-long-vertical.svg": 75982,
	"./np-rectangle.svg": 85376,
	"./np-snake-horizontal.svg": 22132,
	"./np-snake-vertical.svg": 45970,
	"./open-arrow-circle.svg": 327,
	"./person.svg": 3317,
	"./play.svg": 94916,
	"./plus-circle.svg": 33959,
	"./plus-small.svg": 33760,
	"./rss.svg": 80290,
	"./search.svg": 74510,
	"./share-big.svg": 510,
	"./share-new-profile-small.svg": 72344,
	"./share-purple.svg": 24882,
	"./share-small.svg": 98585,
	"./slideshow.svg": 75630,
	"./small-arrow-down.svg": 16652,
	"./small-arrow-right.svg": 58750,
	"./some-facebook.svg": 16307,
	"./some-instagram.svg": 75601,
	"./some-linkedin.svg": 78821,
	"./some-rss.svg": 8217,
	"./sort-down.svg": 83439,
	"./sort-up.svg": 60160,
	"./star.svg": 62814,
	"./stop.svg": 90750,
	"./video.svg": 46667,
	"./volume.svg": 80460,
	"./warning-circle.svg": 14927,
	"./warning-color.svg": 19220,
	"./warning-triangle.svg": 50451,
	"./warning.svg": 76002,
	"./wrench.svg": 54977,
	"./x-circle.svg": 28239,
	"./x-rounded.svg": 86906,
	"./x-straight.svg": 16457,
	"./x.svg": 74370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17853;